import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnerShipModel } from './peer-ownership.model';

export class PeerAndIndustryOwnershipConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerAndIndustryOwnershipConfiguration';
  nodataLocalizationKeyName = 'peerAndIndustryOwnership';
  readonly reportSection = ReportSection.PeerOwnership;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_PeerOwnership];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections = [
    {
      name: 'peerAndIndustryOwnershipIndValue',
      displayName: 'Value My Industry USD, mm',
      isSelected: true,
      canConfigure: true,
      property: 'valueMyIndustry'
    },
    {
      name: 'peerAndIndustryOwnershipIndHoldings',
      displayName: 'Holdings My Industry',
      isSelected: true,
      canConfigure: true,
      property: 'numberOfHoldingsMyIndustry'
    },
    {
      name: 'peerAndIndustryOwnershipPeersNum',
      displayName: 'Number of Peers',
      isSelected: true,
      canConfigure: true,
      property: 'numberOfPeers'
    },
    {
      name: 'peerAndIndustryOwnershipPeersPctPort',
      displayName: '% Portfolio My Security',
      isSelected: true,
      canConfigure: true,
      property: 'portPctMyHoldings'
    },
    {
      name: 'peerAndIndustryOwnershipPeersPctAvg',
      displayName: '% Portfolio Avg. Peers',
      isSelected: true,
      canConfigure: true,
      property: 'portPctAvgPeers'
    },
    {
      name: 'peerAndIndustryOwnershipPeersPctAggr',
      displayName: '% Portfolio Aggr. Peers',
      isSelected: true,
      canConfigure: true,
      property: 'portPctAggrPeers'
    },
    {
      name: 'peerAndIndustryOwnershipPeersAggrValue',
      displayName: 'Aggr. Peers Value USD, mm',
      isSelected: true,
      canConfigure: true,
      property: 'aggrPeersValue'
    },
    {
      name: 'peerAndIndustryOwnershipIndGrid',
      displayName: 'Industry Holdings',
      type: ReportSectionConfigurationControlType.Table,
      isSelected: true,
      canConfigure: true,
      subSections: [
        {
          name: 'peerAndIndustryOwnershipIndGridName',
          displayName: 'Industry Name',
          isSelected: true,
          canConfigure: false,
          unit: 5,
          property: 'industryName',
          isStatic: true,
          type: ReportSectionConfigurationControlType.Text
        },
        {
          name: 'peerAndIndustryOwnershipIndGridPctSO',
          displayName: '% Portfolio',
          isSelected: true,
          canConfigure: true,
          unit: 1,
          property: 'portfolioPct',
          type: ReportSectionConfigurationControlType.Text
        }
      ],
      canReorderSubSections: true
    },
    {
      name: 'peerAndIndustryOwnershipPeersGrid',
      displayName: 'Peers Holdings',
      type: ReportSectionConfigurationControlType.Table,
      isSelected: true,
      canConfigure: true,
      subSections: [
        {
          name: 'peerAndIndustryOwnershipPeersGridName',
          displayName: 'Peer Name',
          isSelected: true,
          canConfigure: false,
          unit: 5,
          property: 'securityIssuerName',
          isStatic: true,
          type: ReportSectionConfigurationControlType.Text
        },
        {
          name: 'peerAndIndustryOwnershipPeersGridValue',
          displayName: 'Value USD, mm',
          isSelected: true,
          canConfigure: true,
          unit: 2,
          property: 'value',
          type: ReportSectionConfigurationControlType.Decimal
        },
        {
          name: 'peerAndIndustryOwnershipPeersGridPctSO',
          displayName: 'Portfolio',
          isSelected: true,
          canConfigure: true,
          unit: 1,
          property: 'portfolioPct',
          type: ReportSectionConfigurationControlType.Text
        },
        {
          name: 'peerAndIndustryOwnershipPeersGridValueChange',
          displayName: 'Share Change Value USD, mm',
          isSelected: true,
          canConfigure: true,
          unit: 2,
          property: 'sharesChangeValue',
          type: ReportSectionConfigurationControlType.Decimal
        }
      ],
      canReorderSubSections: true
    }
  ];

  get name(): string {
    if (this.appliedReportType === 'Contact') {
      return 'contactPeerAndIndustryOwnership';
    } else if (this.appliedReportType === 'Institution') {
      return 'institutionPeerAndIndustryOwnership';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === 'Contact' || this.appliedReportType === 'Institution') {
      return 'Peer & Industry Ownership';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface PeerOwnershipDetailsData {
  [ReportViewModelSection.InvestorProfile_PeerOwnership]: PeerOwnerShipModel;
}
